export const site = {
  name: 'Horizons Window Cleaning',
  phone: '(555) 019-4820',
  email: 'hello@horizonswindows.com',
  hours: 'Mon–Sat · 7am – 6pm'
}

export type Service = {
  id: string
  title: string
  blurb: string
  bullets: string[]
  price: string
  image?: string
}

export const services: Service[] = [
  {
    id: 'residential',
    title: 'Residential Windows',
    blurb:
      'Interior and exterior glass, screens, sills and tracks — cleaned by hand, streak free, every time.',
    bullets: ['Inside + outside glass', 'Screens washed', 'Tracks & sills detailed'],
    price: 'from $189',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ce523732-4745-4ede-87eb-990f24d1ed71.jpg'
  },
  {
    id: 'commercial',
    title: 'Commercial & Storefront',
    blurb:
      'Weekly, monthly or quarterly routes that keep your first impression spotless before doors open.',
    bullets: ['Flexible route schedules', 'Before-hours service', 'Insured crews'],
    price: 'custom routes',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/45e30b77-26e1-4976-96e3-f427126cc216.jpg'
  },
  {
    id: 'gutters',
    title: 'Gutter Cleaning',
    blurb:
      'Hand-scooped debris, flushed downspouts and a quick flow check so water goes where it should.',
    bullets: ['Debris hauled away', 'Downspouts flushed', 'Photo report included'],
    price: 'from $149',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/98de3f60-59a5-48d3-90d4-e85dc8446ced.jpg'
  },
  {
    id: 'softwash',
    title: 'House & Soft Wash',
    blurb:
      'Low-pressure soft washing that lifts algae, pollen and grime without harming siding or plants.',
    bullets: ['Siding & soffits', 'Plant-safe solution', 'Driveways & walkways'],
    price: 'from $299'
  }
]

export const stats = [
  { value: '12k+', label: 'Windows cleaned' },
  { value: '4.9★', label: 'Average rating' },
  { value: '100%', label: 'Streak-free promise' },
  { value: '10 yrs', label: 'In business' }
]

export const steps = [
  {
    number: '01',
    title: 'Get your quote',
    text: 'Send us a few details about your home or building. We reply with a flat, all-in price — usually the same day.'
  },
  {
    number: '02',
    title: 'Pick your day',
    text: 'Choose a time that works. You get a confirmation, a two-hour arrival window, and a text when we are on the way.'
  },
  {
    number: '03',
    title: 'We make it disappear',
    text: 'Shoes off, drop cloths down, glass detailed by hand. We walk the job with you before we pack up.'
  }
]

export const testimonials = [
  {
    quote:
      'I genuinely thought a pane was missing. The crew was polite, quick, and left the sills cleaner than the glass.',
    name: 'Dana R.',
    role: 'Homeowner'
  },
  {
    quote:
      'They handle our storefront before we open every other week. Never a missed visit in three years.',
    name: 'Marcus O.',
    role: 'Café owner'
  },
  {
    quote:
      'Flat pricing, no upsell theater, and photos of the gutters when they finished. Exactly what I wanted.',
    name: 'Priya S.',
    role: 'Homeowner'
  }
]

export const faqs = [
  {
    q: 'Do I need to be home during the service?',
    a: 'Only if we are cleaning interior glass. For exterior-only work, just make sure gates are unlocked and we will text you photos when the job is done.'
  },
  {
    q: 'What if it rains after you clean?',
    a: 'Rain on clean glass stays clean. If a storm leaves spotting within 7 days, we come back and touch it up free.'
  },
  {
    q: 'Are you insured?',
    a: 'Fully licensed and insured, with every technician background-checked and trained in ladder and rope safety.'
  },
  {
    q: 'How often should windows be cleaned?',
    a: 'Twice a year keeps most homes looking sharp. Storefronts and homes near trees, salt air or construction usually do best on a monthly or quarterly route.'
  },
  {
    q: 'What does it cost?',
    a: 'Pricing is based on pane count and access, not guesswork. You get one flat number up front and it does not change on the day.'
  }
]
